// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/imbanner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/Website-Mobile-Banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-horizontal {
  overflow: hidden;
}
.r-buttons {
    position: relative;
    gap: 1rem;
    bottom: -2rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    top: 17px;
}
.r-buttons button {
    font-size: 1.2rem;
    padding: 0.2rem 0.8rem;
    color: blue;
    border: none;
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
}
.r-buttons > :nth-child(1) {
    background-color: #2067D1;
    color: white;
}
.r-buttons > :nth-child(2) {
    background-color: #2067D1;
    color: white;
}
.main-slider {
  /* background: url('https://res.cloudinary.com/deiuirtja/image/upload/v1713934028/investmango/Image-01_1_bssioj.jpg') !important; */
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})!important;
  background-position: center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
}
.main-slider {
    position: relative;
  }
  .form-top-home form {
    max-width: 600px;
    margin: 0 auto;
  }
  a:hover {
    text-decoration: none;
  }
  @media (width <= 768px) {
    .form-top-home {
      position: static;
      margin-top: 20px;
      transform: none;
    }
    .main-slider {
      height: auto;
    }
    .main-slider {
      /* background: url('https://res.cloudinary.com/deiuirtja/image/upload/v1713934028/investmango/Image-01_1_bssioj.jpg') !important; */
      background: url(${___CSS_LOADER_URL_REPLACEMENT_1___})!important;
      background-position: center !important;
      background-size: cover !important;
      background-repeat: no-repeat !important;
    }
  }
  /* @media (width >= 769px) {
    .main-slider {
      height: 80vh;
    }
  } */
  .card-im{
    border-radius: 20px;
    width: 340px;
    margin: auto;
    max-width: 100%;
    background-color: #F7F7F7;
    padding: 20px;
}
.testimonial-container {
  padding: 50px 0;
  background-color: #F9F9F9;
  text-align: center;
}
.testimonial-item {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgb(0 0 0 / 10%);
  text-align: center;
}
.stars {
  margin-bottom: 10px;
}
.fa-star.checked {
  color: #fc0;
}
.testimonial-text {
  font-style: italic;
  margin-bottom: 15px;
}
.testimonial-name {
  font-weight: bold;
  font-size: 1.2em;
}
.testimonial-role {
  color: #666;
}
/* .swiper-button-next,
.swiper-button-prev {
  position: absolute;
  top: 100%;
  transform: translateY(-50%);
  color: white;
  transition: color 0.3s;
  width: 5%;
  height: 59px;
  border-radius: 54px;
  font-weight: 600;
  font-size: 40px;
  background-color: #2067D1;
  z-index: 10;
}
.swiper-button-next {
  right: 40%;
}
.swiper-button-prev {
  left: 50%;
} */
/* Center the Swiper navigation buttons below the cards */
.swiper-container {
  position: relative;
  padding-bottom: 50px; /* Space for navigation */
}

/* Custom Navigation Buttons (Visible Only on Desktop) */
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 45px;
  height: 45px;
  background: white; /* Default: White background */
  color: black; /* Default: Black arrow */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;

  /* Adding Soft Shadow */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

/* Hover Effect */
.swiper-button-prev:hover,
.swiper-button-next:hover {
  background: #2067D1; /* Blue background on hover */
  color: white; /* White arrow on hover */
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.3); /* Stronger shadow */
}


/* Button Positions */
.swiper-button-prev {
  left: 15px;
}

.swiper-button-next {
  right: 15px;
}

/* Hide Navigation Buttons on Tablets & Mobile */
@media (max-width: 1024px) {
  .swiper-button-prev,
  .swiper-button-next {
    display: none !important;
  }
}

.swiper-button-prev::after, 
.swiper-button-next::after {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/Home.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;EACE,mIAAmI;EACnI,6DAAwD;EACxD,sCAAsC;EACtC,iCAAiC;EACjC,uCAAuC;AACzC;AACA;IACI,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE;MACE,gBAAgB;MAChB,gBAAgB;MAChB,eAAe;IACjB;IACA;MACE,YAAY;IACd;IACA;MACE,mIAAmI;MACnI,6DAAqE;MACrE,sCAAsC;MACtC,iCAAiC;MACjC,uCAAuC;IACzC;EACF;EACA;;;;KAIG;EACH;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,aAAa;AACjB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;;;;;;;;;;;;;;;;;;;;GAoBG;AACH,yDAAyD;AACzD;EACE,kBAAkB;EAClB,oBAAoB,EAAE,yBAAyB;AACjD;;AAEA,wDAAwD;AACxD;;EAEE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,8BAA8B;EACjD,YAAY,EAAE,yBAAyB;EACvC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;;EAEX,4FAA4F;;EAE5F,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;;EAEE,mBAAmB,EAAE,6BAA6B;EAClD,YAAY,EAAE,yBAAyB;EACvC,2CAA2C,EAAE,oBAAoB;AACnE;;;AAGA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,gDAAgD;AAChD;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;;IAEI,aAAa;AACjB","sourcesContent":[".swiper-horizontal {\n  overflow: hidden;\n}\n.r-buttons {\n    position: relative;\n    gap: 1rem;\n    bottom: -2rem;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    justify-content: center;\n    top: 17px;\n}\n.r-buttons button {\n    font-size: 1.2rem;\n    padding: 0.2rem 0.8rem;\n    color: blue;\n    border: none;\n    border-radius: 5px;\n    background-color: white;\n    cursor: pointer;\n}\n.r-buttons > :nth-child(1) {\n    background-color: #2067D1;\n    color: white;\n}\n.r-buttons > :nth-child(2) {\n    background-color: #2067D1;\n    color: white;\n}\n.main-slider {\n  /* background: url('https://res.cloudinary.com/deiuirtja/image/upload/v1713934028/investmango/Image-01_1_bssioj.jpg') !important; */\n  background: url('/public/images/imbanner.png')!important;\n  background-position: center !important;\n  background-size: cover !important;\n  background-repeat: no-repeat !important;\n}\n.main-slider {\n    position: relative;\n  }\n  .form-top-home form {\n    max-width: 600px;\n    margin: 0 auto;\n  }\n  a:hover {\n    text-decoration: none;\n  }\n  @media (width <= 768px) {\n    .form-top-home {\n      position: static;\n      margin-top: 20px;\n      transform: none;\n    }\n    .main-slider {\n      height: auto;\n    }\n    .main-slider {\n      /* background: url('https://res.cloudinary.com/deiuirtja/image/upload/v1713934028/investmango/Image-01_1_bssioj.jpg') !important; */\n      background: url('/public/images/Website-Mobile-Banner.jpg')!important;\n      background-position: center !important;\n      background-size: cover !important;\n      background-repeat: no-repeat !important;\n    }\n  }\n  /* @media (width >= 769px) {\n    .main-slider {\n      height: 80vh;\n    }\n  } */\n  .card-im{\n    border-radius: 20px;\n    width: 340px;\n    margin: auto;\n    max-width: 100%;\n    background-color: #F7F7F7;\n    padding: 20px;\n}\n.testimonial-container {\n  padding: 50px 0;\n  background-color: #F9F9F9;\n  text-align: center;\n}\n.testimonial-item {\n  background: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 10px rgb(0 0 0 / 10%);\n  text-align: center;\n}\n.stars {\n  margin-bottom: 10px;\n}\n.fa-star.checked {\n  color: #fc0;\n}\n.testimonial-text {\n  font-style: italic;\n  margin-bottom: 15px;\n}\n.testimonial-name {\n  font-weight: bold;\n  font-size: 1.2em;\n}\n.testimonial-role {\n  color: #666;\n}\n/* .swiper-button-next,\n.swiper-button-prev {\n  position: absolute;\n  top: 100%;\n  transform: translateY(-50%);\n  color: white;\n  transition: color 0.3s;\n  width: 5%;\n  height: 59px;\n  border-radius: 54px;\n  font-weight: 600;\n  font-size: 40px;\n  background-color: #2067D1;\n  z-index: 10;\n}\n.swiper-button-next {\n  right: 40%;\n}\n.swiper-button-prev {\n  left: 50%;\n} */\n/* Center the Swiper navigation buttons below the cards */\n.swiper-container {\n  position: relative;\n  padding-bottom: 50px; /* Space for navigation */\n}\n\n/* Custom Navigation Buttons (Visible Only on Desktop) */\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 45px;\n  height: 45px;\n  background: white; /* Default: White background */\n  color: black; /* Default: Black arrow */\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  \n  transition: background 0.3s ease-in-out, color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n\n  /* Adding Soft Shadow */\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* Hover Effect */\n.swiper-button-prev:hover,\n.swiper-button-next:hover {\n  background: #2067D1; /* Blue background on hover */\n  color: white; /* White arrow on hover */\n  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.3); /* Stronger shadow */\n}\n\n\n/* Button Positions */\n.swiper-button-prev {\n  left: 15px;\n}\n\n.swiper-button-next {\n  right: 15px;\n}\n\n/* Hide Navigation Buttons on Tablets & Mobile */\n@media (max-width: 1024px) {\n  .swiper-button-prev,\n  .swiper-button-next {\n    display: none !important;\n  }\n}\n\n.swiper-button-prev::after, \n.swiper-button-next::after {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
